import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export default function Preview(props) {
  const { preview, imageSrc, onClick } = props;
  if (preview) {
    return (
      <>
        {imageSrc && (
          <div className="image-preview">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
              onClick={onClick}
              className={`${imageSrc ? "d-block" : "d-none"}`}
            />

            <img src={imageSrc} alt="img" />
          </div>
        )}
      </>
    );
  }
  return <div></div>;
}
